import React, { memo } from 'react'
import { Box } from '@mui/material'

import Text from '../text/Text'

const StatusLabel = ({ label, color, sx }) => {
  const size = sx ? '5px' : '10px'
  return (
    <Box display='flex' alignItems='center'>
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette[color]?.main,
          borderRadius: '100%',
          height: size,
          width: size
        }}
      />
      <Text
        label={label}
        variant='h6'
        color='textSecondary'
        noWrap
        sx={{ pl: 1, ...sx }}
      />
    </Box>
  )
}

export default memo(StatusLabel)
